import React from "react";

import FormFactory from "../../../../components/form/form-factory";
import ConfirmModal from "../../../../components/modals/confirm-modal";

import * as S from "./styles";

import IProps from "./props";

const AdminRecoveryPassword = ({
  onSubmit,
  dataForm,
  errorMessage,
  handleConfirm,
  isVisible,
}: IProps): JSX.Element => (
  <S.Container>
    <ConfirmModal
      isVisible={isVisible}
      toggleVisibility={handleConfirm}
      text="Senha alterada com sucesso!"
      onConfirm={handleConfirm}
    />
    <S.Title>Alterar a sua Senha</S.Title>
    <S.SubTitle>Digite sua nova senha</S.SubTitle>
    <FormFactory
      data={dataForm}
      onSubmit={onSubmit}
      submitErrorMessage={errorMessage}
    />
  </S.Container>
);
export default AdminRecoveryPassword;
